<template>
  <div>
    <template v-if="data">
      <div class="font-weight-bold" pb-2>90 Days</div>
      <v-card>
        <v-layout row>
          <v-flex
            xs4
            :class="`${cardColorClass} lighten-4`"
            style="display: flex"
            align-center
            justify-center
          >
            <v-img src="/static/img/icon-gauge.png" height="150px" contain></v-img>
          </v-flex>
          <v-flex xs8 :class="`${cardColorClass}`">
            <v-card-title primary-title>
              <div>
                <div class="title pb-3">{{ data.msg_1 }}</div>
                <div class="body-1 pb-2">{{ data.msg_2 }}</div>
                <div class="body-1">{{ data.msg_3 }}</div>
              </div>
            </v-card-title>
            <div class="text-xs-right">
              <v-btn
                flat
                :dark="data.msg_1 !== 'ความเสี่ยงปานกลาง'"
                @click="showAssessment3Months = true"
              >
                <span>รายละเอียดเพิ่มเติม</span>
                <em class="fas fa-chevron-right white--text ml-2 pt-1"></em
              ></v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </template>

    <v-dialog v-model="showAssessment3Months" persistent width="800px">
      <v-card class="pa-3">
        <div class="primary--text">แบบประเมินย้อนหลัง 3 เดือน</div>
        <div class="text-xs-right pt-3">
          วันที่ทำแบบประเมิน
          <span class="pl-1 primary--text">{{ assessmentDate }}</span>
        </div>
        <div class="pt-3">
          <v-data-table
            hide-actions
            :headers="headers"
            :items="assessmentListData"
            class="elevation-1 mt-3"
          >
            <template #items="props">
              <tr>
                <td>{{ props.index + 1 }}</td>
                <td>{{ props.item.title || '-' }}</td>
                <td>{{ props.item.score_title || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div class="text-xs-center pt-3">
          <v-btn depressed color="primary" @click="showAssessment3Months = false">{{
            $t('close')
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      data: [],
      cardColorClass: '',
      showAssessment3Months: false,
      headers: [
        { text: 'ข้อที่', value: 'key', sortable: false },
        { text: 'คำถาม', value: 'title', sortable: false },
        { text: 'คำตอบ', value: 'score_title', sortable: false }
      ],
      assessmentListData: [],
      assessmentLastTime: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    assessmentDate() {
      return this.assessmentLastTime ? moment(this.assessmentLastTime).format('DD/MM/YYYY') : '-'
    }
  },
  async mounted() {
    await this.handleGetInitial()
    this.handleGetAssessment3Months()
  },
  methods: {
    async handleGetInitial() {
      const vm = this
      try {
        const response = await vm.getSummary3Months()
        if (response) {
          vm.data = response.data
          let currentStatus = response.data.msg_1
          vm.handleGetStatusColor(currentStatus)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getSummary3Months() {
      const vm = this
      let member_id = vm.$route && vm.$route.params.id
      let data = {
        page_id: vm.selectedBot.pageid
      }

      vm.loading = true
      const response = await nongtungjaiApi.getSummary3Months(
        {
          config: {
            params: data
          }
        },
        member_id
      )

      vm.loading = false
      if (response && response.status === 200) {
        return response.data
      } else {
        return null
      }
    },
    handleGetStatusColor(status) {
      if (status) {
        let color = ''
        switch (status) {
          case 'ความเสี่ยงต่ำ':
            color = 'success'
            break
          case 'ความเสี่ยงปานกลาง':
            color = 'yellow'
            break
          case 'ความเสี่ยงสูง':
            color = 'error'
            break

          default:
            color = 'primary'
            break
        }
        this.cardColorClass = color
      }
    },
    async handleGetAssessment3Months() {
      const vm = this
      try {
        let memberId = vm.$route && vm.$route.params.id
        let data = {
          page_id: vm.selectedBot.pageid
        }
        const response = await nongtungjaiApi.getAssessment3Months({
          config: {
            params: data
          },
          memberId: memberId
        })

        // if (response && response.status === 200) {
        vm.assessmentLastTime = response.data.last_time
        vm.assessmentListData = response.data.data
        // }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/PatientSummaryCard.vue